import fpApiUtil from "./fp-api-util";

// MasterController POST /factoryplan/master/bom/* — BOM 전개(트리 그리드 / 다이어그램) 조회 전용.
// 정전개(forward)/역전개(backward)가 서로 다른 엔드포인트이고, 요청 파라미터의 bomTpCd도 같이
// 바뀐다(정전개 'P' = 이 품목을 만드는 BOM, 역전개 'C' = 이 품목을 쓰는 BOM). old
// `master/bom/Bom.jsx`의 loadBom / `BomDiagram.jsx`의 loadBomDiagram과 동일한 계약.
const BASE = "factoryplan/master/bom";

// 트리 그리드용 — 각 노드가 자기 자식을 `children`에 담은 재귀 트리(MasterService#getBomTreeTopDown).
const getBomTree = (params) => fpApiUtil.postParams(`${BASE}/bomtree`, params);
const getBomTreeReverse = (params) => fpApiUtil.postParams(`${BASE}/bomtree/reverse`, params);

// 다이어그램용 — FLO와 같은 모양의 트리(MasterService#getBomDiagram → getFlo). FLO는 인벤토리
// 코드로 조회하지만 이쪽은 품목 코드로 조회하고 백엔드가 인벤토리를 찾아 넘긴다.
const getBomDiagram = (params) => fpApiUtil.postParams(`${BASE}/bom-diagram`, params);
const getBomDiagramReverse = (params) => fpApiUtil.postParams(`${BASE}/bom-diagram/reverse`, params);

const fpBomService = { getBomTree, getBomTreeReverse, getBomDiagram, getBomDiagramReverse };
export default fpBomService;
